var $21cdd87e84f28d89$exports = {};
$21cdd87e84f28d89$exports = {
    "hue": `Hue`,
    "saturation": `Saturation`,
    "lightness": `Lightness`,
    "brightness": `Brightness`,
    "red": `Red`,
    "green": `Green`,
    "blue": `Blue`,
    "alpha": `Alpha`
};


export {$21cdd87e84f28d89$exports as default};
//# sourceMappingURL=en-US.module.js.map
